/* Sunday: 100 nights journey (sections/sunday-nights.liquid). The bar fills with the scroll (--p 0–1), each stop's
   moon lights as the fill reaches it. The big number stays as printed (the moons already show the progress).
   Reduced motion or no IntersectionObserver: the finished state the server printed (--p:1, every moon lit). */
(function () {
  var calm = false;
  /* 24 Oct (AR go): plays with reduced motion too */
  if (calm || !('IntersectionObserver' in window)) return;
  document.querySelectorAll('[data-nj]:not([data-nj-on])').forEach(function (sec) {
    sec.setAttribute('data-nj-on', '');
    var track = sec.querySelector('[data-nj-track]'), stops = track ? track.querySelectorAll('.sd-njs') : [];
    var raf = 0, live = false;
    function paint() {
      raf = 0;
      var r = track.getBoundingClientRect(), vh = innerHeight || 800;
      var start = vh * 0.85, span = vh * 0.3 + (r.height > 120 ? r.height * 0.4 : 0);
      var p = Math.max(0, Math.min(1, (start - r.top) / span));
      sec.style.setProperty('--p', p.toFixed(3));
      stops.forEach(function (s, i) { s.classList.toggle('on', i === 0 || p >= parseFloat(s.getAttribute('data-at')) - 0.001); });
    }
    function onScroll() { if (live && !raf) raf = requestAnimationFrame(paint); }
    // Only animate what starts below the screen; a section already in view keeps its finished state.
    var r0 = sec.getBoundingClientRect();
    if (r0.top < (innerHeight || 800) * 0.9) return;
    if (track) { sec.style.setProperty('--p', '0'); stops.forEach(function (s, i) { if (i) s.classList.remove('on'); }); }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        live = e.isIntersecting;
        if (live && track) paint();
      });
    }, { threshold: [0, 0.25, 0.5] }).observe(sec);
    document.addEventListener('scroll', onScroll, { passive: true, capture: true }); // capture: also when an inner box is the page scroller
    addEventListener('resize', onScroll, { passive: true });
  });
})();
